import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { navigate } from "@reach/router";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import Divider from "@material-ui/core/Divider";
import styles from "./styles";

class Summary extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { classes, t, nickname, product } = this.props;
    return (
      <React.Fragment>
        <div className={classes.headerSection}>
          <i
            className={`material-icons ${classes.headerIcon}`}
            onClick={() => navigate("products")}
          >
            keyboard_arrow_left
          </i>
          <h4 className={classes.headerBreadCrumb}>
            {t("screens.summary.breadCrumb")}
          </h4>
        </div>
        <div className={classes.body}>
          <div className={classes.titleSection}>
            <h1 className={classes.title}>{t("screens.summary.title")}</h1>
            <h2 className={classes.subTitle}>{nickname}</h2>
          </div>
          <div className={classes.listSection}>
            <div className={classes.listItem}>
              <h3 className={classes.listProduct}>{product.packageName}</h3>
              <Chip className={classes.listChip} label={`$ ${product.price}`} />
            </div>
          </div>
          <div className={classes.totalSection}>
            <div className={classes.totalItems}>
              <Divider />
              <h3 className={`${classes.total} ${classes.totalDescription}`}>
                Total:
              </h3>
              <h3
                className={`${classes.total} ${classes.totalAmount}`}
              >{`$ ${product.price}/mo`}</h3>
            </div>
          </div>
          <div className={classes.actionsSection}>
            <Button
              onClick={() => navigate("summary")}
              className={classes.actions}
              variant="contained"
              size="large"
              color="primary"
            >
              {t("screens.summary.action")}
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

Summary.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  product: PropTypes.object
};

Summary.defaultProps = {
  product: {}
};

const mapStateToProps = ({ up, products }) => ({
  nickname: up.profile.nickname,
  product: products.selected_product
});

const mapDispatchToProps = dispatch => ({});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(Summary))
);
